import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import { DataSource, Repository } from "typeorm"
import { CommonResponseModel } from "@project-management-system/shared-models"
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object"
import { LocationEntity } from "./location.entity"
import { LocationDto } from "./location.dto"


@Injectable()
export class LocationService {
    constructor(
        @InjectRepository(LocationEntity)

        private repo: Repository<LocationEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createLocation(req: LocationDto): Promise<CommonResponseModel> {

        try {

            const Check = await this.repo.find({ where: { locationName: req.locationName, address: req.address, gps: req.gpsLocation } })
            if (Check.length > 0) {
                return new CommonResponseModel(false, 0, 'Location already exists')
            }
            const entity = new LocationEntity()
            entity.locationName = req.locationName;
            entity.address = req.address;
            entity.gps = req.gpsLocation;
            entity.plantId = req.plantId;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;
            if (req.id) {
                entity.updatedUser = req.createdUser
            } else {
                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in Location creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllLocation(): Promise<CommonResponseModel> {
        const query =
            `SELECT
                location_name AS locationName,p.plant_id AS plantId,p.plant_name AS plantName, 
                address AS address, 
                gps_location AS gpsLocation, l.is_active AS isActive 
            FROM 
                location l left join plants p on p.plant_id = l.plant_id;`
        const data = await this.dataSource.query(query);

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    } catch(err) {
        return err;
    }

    async getActiveAllLocation(): Promise<CommonResponseModel> {
        const data = await this.repo.find({
            where: {
                isActive: true
            }
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async updateLocation(req: LocationDto): Promise<CommonResponseModel> {
        // console.log("updateemployee==", req)
        try {
            let Product;
            Product = await this.repo.update(
                { id: req.id },
                {
                    locationName: req.locationName,
                    address: req.address,
                    gps: req.gpsLocation
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateLocation(req: LocationDto): Promise<CommonResponseModel> {
        try {
            // console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Location information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Location is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Location is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Location is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Location is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }




}